export const locales = [
  {
    name: { en: "English", es: "Inglés", fr: "Anglais" },
    code: "/en/",
    flag: require("@/assets/flags/united-kingdom.png"),
  },
  {
    name: { en: "French", es: "Francés", fr: "Français" },
    code: "/fr/",
    flag: require("@/assets/flags/france.png"),
  },
  {
    name: { en: "Spanish", es: "Español", fr: "Espagnol" },
    code: "/es/",
    flag: require("@/assets/flags/spain.png"),
  },
  {
    name: { en: "Italian", es: "Italiano", fr: "Italien" },
    code: "/it/",
    flag: require("@/assets/flags/italy.png"),
  },
  {
    name: { en: "Portuguese", es: "Portugués", fr: "Portugais" },
    code: "/pt/",
    flag: require("@/assets/flags/portugal.png"),
  },
  {
    name: { en: "German", es: "Alemán", fr: "Allemand" },
    code: "/de/",
    flag: require("@/assets/flags/germany.png"),
  },
  {
    name: { en: "Dutch", es: "Neerlandés", fr: "Néerlandais" },
    code: "/nl/",
    flag: require("@/assets/flags/netherlands.png"),
  },
  {
    name: { en: "Polish", es: "Polaco", fr: "Polonais" },
    code: "/pl/",
    flag: require("@/assets/flags/poland.png"),
  },
  {
    name: { en: "Swedish", es: "Sueco", fr: "Suédois" },
    code: "/sv/",
    flag: require("@/assets/flags/sweden.png"),
  },
  {
    name: { en: "Finnish", es: "Finés", fr: "Finnois" },
    code: "/fi/",
    flag: require("@/assets/flags/finland.png"),
  },
  {
    name: { en: "Norwegian", es: "Noruego", fr: "Norvégien" },
    code: "/no/",
    flag: require("@/assets/flags/norway.png"),
  },
  {
    name: { en: "Danish", es: "Danés", fr: "Danois" },
    code: "/da/",
    flag: require("@/assets/flags/denmark.png"),
  },
  {
    name: { en: "Russian", es: "Ruso", fr: "Russe" },
    code: "/ru/",
    flag: require("@/assets/flags/russia.png"),
  },
  {
    name: { en: "Greek", es: "Griego", fr: "Grec" },
    code: "/el/",
    flag: require("@/assets/flags/greece.png"),
  },
  {
    name: { en: "Turkish", es: "Turco", fr: "Turc" },
    code: "/tr/",
    flag: require("@/assets/flags/turkey.png"),
  },
  {
    name: { en: "Hungarian", es: "Húngaro", fr: "Hongrois" },
    code: "/hu/",
    flag: require("@/assets/flags/hungary.png"),
  },
  {
    name: { en: "Czech", es: "Checo", fr: "Tchèque" },
    code: "/cs/",
    flag: require("@/assets/flags/czech-republic.png"),
  },
  {
    name: { en: "Slovak", es: "Eslovaco", fr: "Slovaque" },
    code: "/sk/",
    flag: require("@/assets/flags/slovakia.png"),
  },
  {
    name: { en: "Romanian", es: "Rumano", fr: "Roumain" },
    code: "/ro/",
    flag: require("@/assets/flags/romania.png"),
  },
  {
    name: { en: "Bulgarian", es: "Búlgaro", fr: "Bulgare" },
    code: "/bg/",
    flag: require("@/assets/flags/bulgaria.png"),
  },
  {
    name: { en: "Croatian", es: "Croata", fr: "Croate" },
    code: "/hr/",
    flag: require("@/assets/flags/croatia.png"),
  },
  {
    name: { en: "Bosnian", es: "Bosnio", fr: "Bosnien" },
    code: "/bs/",
    flag: require("@/assets/flags/bosnia-and-herzegovina.png"),
  },
  {
    name: { en: "Slovenian", es: "Esloveno", fr: "Slovène" },
    code: "/sl/",
    flag: require("@/assets/flags/slovenia.png"),
  },
  {
    name: { en: "Latvian", es: "Letón", fr: "Letton" },
    code: "/lv/",
    flag: require("@/assets/flags/latvia.png"),
  },
  {
    name: { en: "Lithuanian", es: "Lituano", fr: "Lituanien" },
    code: "/lt/",
    flag: require("@/assets/flags/lithuania.png"),
  },
  {
    name: { en: "Ukrainian", es: "Ucraniano", fr: "Ukrainien" },
    code: "/uk/",
    flag: require("@/assets/flags/ukraine.png"),
  },
  {
    name: { en: "Hindi", es: "Hindi", fr: "Hindi" },
    code: "/hi/",
    flag: require("@/assets/flags/india.png"),
  },
  {
    name: { en: "Chinese (Mandarin)", es: "Chino (Mandarín)", fr: "Chinois (mandarin)" },
    code: "/zh/",
    flag: require("@/assets/flags/china.png"),
  },
  {
    name: { en: "Japanese", es: "Japonés", fr: "Japonais" },
    code: "/ja/",
    flag: require("@/assets/flags/japan.png"),
  },
  {
    name: { en: "Korean", es: "Coreano", fr: "Coréen" },
    code: "/ko/",
    flag: require("@/assets/flags/south-korea.png"),
  },
  {
    name: { en: "Arabic", es: "Árabe", fr: "Arabe" },
    code: "/ar/",
    flag: require("@/assets/flags/saudi-arabia.png"),
  },
  {
    name: { en: "Indonesian", es: "Indonesio", fr: "Indonésien" },
    code: "/id/",
    flag: require("@/assets/flags/indonesia.png"),
  },
];
